// Angular
import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

// Platform
import { HotkeyModule, IHotkeyOptions } from 'angular2-hotkeys';
import { CerRouteSettingsUtil } from './app.module-generated';
import { CerAmountPipe } from '@ui/cer-ui-intl.service';
//import { CerRouteAlwaysReloadRouteStrategy } from '@cer/cer-route/cer-route-allways-reload-route-strategy';

// Cer Core app
import { AppCoreModule } from 'src/app-core/app-core.module';
import { CerAppLayoutMainRouterOutletComponent } from 'src/cer-app/cer-app-layout/cer-app-layout-main-router-outlet/cer-app-layout-main-router-outlet.component';

// Rights
import { RightsApprovalComponent } from './rights/rights-approval/rights-approval.component';

// Royalty
import { RoyaltyApproveComponent } from './royalty/royalty-approve.component';
import { RoyaltyApproveDetailComponent } from './royalty/royalty-approve-detail.component';
import { RoyaltyForlagComponent } from './royalty/royalty-forlag.component';

// Sales
import { SalesOrderCustComponent } from './sales/sales-order-cust.component';

// Voucher
import { VoucherMessageListComponent } from './voucher/vouchermessage-list/vouchermessage-list.component';
import { VoucherListComponent } from './voucher/voucher-list/voucher-list.component';
import { VoucherLookupComponent } from './voucher/voucher-lookup/voucher-lookup.component';
import { VoucherDetailComponent } from './voucher/voucher-detail/voucher-detail.component';
import { VoucherCreateMobileComponent } from './voucher/voucher-create-mobile/voucher-create-mobile.component';
import { BankAccountSettlementComponent } from './bank/settlement/bank-account-settlement.component';

// Contract
import { ContractComponent } from './contract/contract.component';
import { ForfatterComponent } from './contract/forfatter/forfatter.component';

// Product
import { ProductComponent } from './product/product.component';
import { cerAppMainRoute } from 'src/cer-app/cer-app.module';

// Hotkeys
var hotkeyOptions: IHotkeyOptions = {
  disableCheatSheet: false,
  cheatSheetHotkey: '?',
  cheatSheetCloseEsc: true,
  cheatSheetCloseEscDescription: 'Luk denne liste',
  cheatSheetDescription: 'Liste genvejstaster'
};

// Routes
cerAppMainRoute.children = CerRouteSettingsUtil.Routes();
cerAppMainRoute.children.unshift({ path: '', redirectTo: '/home', pathMatch: 'full' });
var appRoutes: Routes = [cerAppMainRoute];

// Module
@NgModule({
  declarations: [
    BankAccountSettlementComponent,
    ContractComponent,
    ForfatterComponent,
    ProductComponent,
    RightsApprovalComponent,
    RoyaltyApproveComponent,
    RoyaltyApproveDetailComponent,
    RoyaltyForlagComponent,
    SalesOrderCustComponent,
    VoucherCreateMobileComponent,
    VoucherDetailComponent,
    VoucherListComponent,
    VoucherLookupComponent,
    VoucherMessageListComponent
  ],
  imports: [
    AppCoreModule,
    //    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    RouterModule.forRoot(appRoutes),
    HotkeyModule.forRoot(hotkeyOptions)
  ],
  exports: [RouterModule],
  providers: [
    CerAmountPipe,
    //    { provide: RouteReuseStrategy,  useClass: CerRouteAlwaysReloadRouteStrategy } 
  ],
  bootstrap: [CerAppLayoutMainRouterOutletComponent]
})
export class AppModule { }
